<div class="card voffset-5">
    <div class="card-body"
         [ngClass]="{'border-red background-panel': item().isRemoved || item().removedOptions.length > 0}">
        <div class="row">
            <div class="col">
                <h6 class="card-title main-blue">{{ item().campName }} - {{ item().sessionName }}</h6>
            </div>
            <div class="col-md-auto">
                @if (item().isRemoved) {
                    <button bcClick (clicked)="onAddBackToPurchase()" class="btn btn-light btn-sm">
                        {{ 'PurchaseEdit.addBackToPurchase' | translate }}
                    </button>
                } @else {
                    <button bcClick (clicked)="onRemoveSession()" class="btn btn-danger btn-sm" hznTestId="purchase-edit-remove-session">
                        {{ 'PurchaseEdit.remove' | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="card-text voffset-10">
            <div class="row">
                <div class="col-sm-6">
                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.location' | translate }}</div>
                        <div class="col-sm-9">{{ item().clubInfo.name }} ({{ item().clubInfo.code }})</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.child' | translate }}</div>
                        <div class="col-sm-9">{{ item().childFullName }}</div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.details' | translate }}</div>
                        <div class="col-sm-9"> {{ timeVariant() }} ({{ item().timeVariant.fromInMinutes | timeDisplay }}
                            - {{ item().timeVariant.toInMinutes | timeDisplay }})
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.campDays' | translate }}</div>
                        <div class="col-sm-9">
                            @for (campDay of item().campDays; track $index) {
                                <span>
                                    {{ campDay | bcDate }}
                                    @if (!$last) {
                                        <span>, </span>
                                    }
                                </span>
                            }
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3 bolded">{{ 'PurchaseEdit.selectedOptions' | translate }}</div>
                        @if (item().options.length > 0) {
                            <div class="col-sm-9">
                                @for (option of item().options; track $index) {
                                    <span>
                                        {{ option.name }}
                                        @if (!$last) {
                                            <span>, </span>
                                        }
                                    </span>
                                }
                            </div>
                        } @else if (item().options.length == 0) {
                            <div class="col-sm-9">{{ 'PurchaseEdit.noneOptions' | translate }}</div>
                        }
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="d-flex justify-content-end">
                        <div class="grid">
                            <div class="bolded text-align-right" translate="PurchaseEdit.tuition"></div>
                            <div class="bolded main-green">{{ item().cost.tuitionAmount | amount }}</div>
                            <div class="main-green">
                                <i class="fa fa-question-circle-o hoffset-10" aria-hidden="true"
                                   href="javascript:void(0)" (mouseover)='isPopoverVisible.set(true)'
                                   (mouseleave)='isPopoverVisible.set(false)'> </i>

                                <div class="explanation-popover-container right">
                                    @if (isPopoverVisible()) {
                                        <div class="bcc-popover-container">
                                            <div class="bcc-popover-right">

                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <span [translate]="'PurchaseEdit.basePrice'"></span>
                                                        <span
                                                            class="main-green right">{{ item().cost.basePrice | amount }}</span>
                                                    </div>
                                                </div>

                                                @for (discount of item().cost.discounts; track $index) {
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <span>{{ discount.name }}:</span>
                                                            <span class="main-red right">
                                                                -{{ discount.value| amount }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div class="bolded text-align-right" translate="PurchaseEdit.additionalOptions"></div>
                            <div class="bolded main-green">{{ item().cost.optionsAmount | amount }}</div>
                            <div></div>

                            @if (options().length > 0) {
                                <div class="separator"></div>
                                @for (option of options(); track option.id) {
                                    <div class="text-align-right" [ngClass]="{'old-price': option.isRemoved}">
                                        {{ option.name }}
                                    </div>
                                    <div [ngClass]="option.isRemoved ? 'old-price' : 'main-green'">
                                        {{ option.pricePerSession | amount }}
                                    </div>
                                    @if (canRemoveOptions() && option.pricePerSession > 0) {
                                        <div>
                                            @if (item().isRemoved) {
                                                <span class="main-grey" translate="PurchaseEdit.optionRemove"></span>
                                            } @else if (option.isRemoved) {
                                                <span bcClick class="main-blue clickable" (click)="onAddOption(option.id)"
                                                    translate="PurchaseEdit.addBackOption"></span>
                                            } @else {
                                                <span bcClick class="main-red clickable" (click)="onRemoveOption(option.id)" hznTestId="purchase-edit-remove-option"
                                                    translate="PurchaseEdit.removeOption"></span>
                                            }
                                        </div>
                                    } @else { 
                                         <!-- To keep grid alignment -->
                                        <div></div>
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
